// Loads Stripe.js on demand (never bundled; Stripe requires loading it from js.stripe.com).
let loading = null;

export const loadStripe = (publishableKey) => {
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      if (window.Stripe) {
        resolve(window.Stripe);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      script.onload = () => resolve(window.Stripe);
      script.onerror = () => {
        loading = null;
        reject(new Error('Could not load the payment form. Check your connection and retry.'));
      };
      document.head.appendChild(script);
    });
  }
  return loading.then((Stripe) => Stripe(publishableKey));
};
